module.exports = __webpack_public_path__ + "img/u3087swww.fda9d77c.png";